import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Loader2, Trash } from "lucide-react";
import type { WhitelistedDomain } from "../types/AdminTypes";

interface DomainsTableProps {
  domains: WhitelistedDomain[] | null;
  isLoading: boolean;
  error: unknown;
  onDelete: (id: string) => void;
}

export function DomainsTable({ domains, isLoading, error, onDelete }: DomainsTableProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-8">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          Error loading domains: {error instanceof Error ? error.message : "Unknown error"}
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Domain</TableHead>
          <TableHead>Tenant</TableHead>
          <TableHead>Created At</TableHead>
          <TableHead className="w-[100px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {domains?.map((domain) => (
          <TableRow key={domain.id}>
            <TableCell>{domain.domain}</TableCell>
            <TableCell>{domain.tenants?.name}</TableCell>
            <TableCell>{new Date(domain.created_at).toLocaleDateString()}</TableCell>
            <TableCell>
              <Button
                variant="destructive"
                size="sm"
                onClick={() => onDelete(domain.id)}
              >
                <Trash className="h-4 w-4" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}